<template>
  <RxkDialog
    :title="warnTipInfo.title"
    width="460px"
    v-model="visible"
    :showFooter="false"
    align-center
    class="authentication-tip-dialog"
    @close="handleClose"
  >
    <div class="authentication-tip-content">
      {{ count }}
      <img v-if="warnTipInfo.type" class="warn-icon" :src="warnTipInfoIcon" />
      <div class="main-content" v-if="warnTipInfo.mainContent || warnTipInfo.toolText">
        <p class="main-text">
          {{ warnTipInfo.mainContent }}
        </p>
        <p class="main-subText" v-if="warnTipInfo.subText">
          {{ warnTipInfo.subText }}
        </p>
        <RxkButton
          class="tool-btn"
          type="text"
          text
          v-if="warnTipInfo.toolText"
          @click="callbackTool"
        >
          {{ warnTipInfo.toolText }}
        </RxkButton>
      </div>
      <slot name="custome" :data="$attrs" />
      <!-- 自定义内容 -->
      <template slot="content">
        <slot name="content" />
      </template>
    </div>
  </RxkDialog>
</template>

<script>
import { RxkDialog } from '@/components/common/RxkDialog'
import { RxkButton } from '@/components/common/RxkButton'
export default {
  name: 'AuthTipsDialog',
  components: { RxkDialog, RxkButton },
  props: {
    showWarnTip: {
      type: Boolean,
      default: false
    },
    warnTipInfo: {
      type: Object,
      default: () => {
        return {
          title: '提示',
          type: 'warn', // success:成功提示 faile：失败提示 warn:未实名认证 pending：等待审核
          mainContent: '',
          toolText: ''
        }
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    visible: {
      get() {
        return this.showWarnTip
      },
      set(v) {
        this.$emit('update:showWarnTip', v)
      }
    },
    warnTipInfoIcon() {
      const { icon = '', type = 'warn' } = this.warnTipInfo
      // icon的优先级高于type
      if (!icon) {
        const typeIconMap = {
          // 目前就两种，可根据业务拓展
          warn: new URL('@/assets/images/icon/warn.jpg', import.meta.url).href,
          success: new URL('@/assets/images/icon/success.jpg', import.meta.url).href,
          move: new URL('@/assets/images/icon/move.png', import.meta.url).href,
          pending: new URL('@/assets/images/icon/pending.jpg', import.meta.url).href,
          faile: new URL('@/assets/images/icon/faile.jpg', import.meta.url).href
        }
        return typeIconMap[type]
      }
      return icon
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    callbackTool() {
      this.$emit('callbackTool')
    }
  }
}
</script>

<style lang="scss" scoped>
.authentication-tip-dialog {
  :deep(.el-dialog__header) {
    padding: 0 24px;
    .el-dialog__headerbtn {
      right: 24px;
      top: 4px;
    }
    .el-dialog__title {
      font-family: 'Microsoft YaHei';
      line-height: 24px;
      font-size: 14px;
    }
  }
  .authentication-tip-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 24px 48px;
    .warn-icon {
      width: 64px;
      height: 64px;
    }
    .main-content {
      margin-top: 20px;
      text-align: center;
      .main-text {
        font-weight: 700;
        color: #333333;
        font-size: 18px;
        font-family: 'Microsoft YaHei';
        line-height: normal;
        font-weight: 400;
      }
      .main-subText {
        color: #999999;
        margin-top: 8px;
        font-size: 14px;

        font-weight: 400;
      }
      .tool-btn {
        margin-top: 4px;
        font-weight: 700;
        font-size: 14px;
      }
    }
  }
}
</style>
